import {MiniLineChart} from "../charts/base/MiniLineChart";
import {shortFormatDateNoTime} from "../../utils/friendlyDate";
import React from "react";
import "./dashboard-box.css";
import ArrowUpRight from "../../assets/icons/ArrowUpRight";
import ArrowDownRight from "../../assets/icons/ArrowDownRight";

interface DashboardBoxProps {
    title: string;
    total: number | string;
    subtotal?: number | string;
    data: any;
    dataKey: string;
}

const DashboardBox = ({ title, total, subtotal = '', data, dataKey }: DashboardBoxProps) => {
    const firstItem = Math.round(data?.[0]?.[dataKey] || 0);
    const lastItem = Math.round(data?.[data.length - 2]?.[dataKey] || 0);
    const difference = firstItem ? Math.abs(Math.round((lastItem - firstItem) / firstItem * 100)) : 0;
    const trend = firstItem > lastItem ? 'down' : firstItem < lastItem ? 'up' : 'equal';
    return (
        <div className="box">
            <div className="box-title">
                {title}
            </div>
            <div className="box-content">
                <div className="period-total">
                    <div>{total}</div>
                </div>
                {difference ? <div className={`period-trend ${trend}`}>
                    {trend === 'up' ? <ArrowUpRight width={14} color='#5ed95e' /> : trend === 'down' ? <ArrowDownRight width={14} color='#ff9090' /> : null }
                    <div>{difference}%</div>
                </div> : null}
                {total ?
                    <div className="period-progress">
                        <MiniLineChart
                            data={data}
                            dataSets={[{label: '', values: data.map((record: any) => parseInt(record[dataKey]))}]}
                            labels={data?.map((record: any) => shortFormatDateNoTime(new Date(record.days)))}
                            isDataLoaded={data.length}
                        />
                    </div>
                : null}
            </div>
        </div>
    );
}

export default DashboardBox;